import { create } from "zustand";

const useTimeTypeStore = create(set => ({
  timeType: "today",
  setTimeType: timeType => set({ timeType })
}));

export default useTimeTypeStore;
